import type {} from "@lit/react";
import { Icon as IconElement, } from "@vaadin/icon/vaadin-icon.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { IconElement, };
export type IconEventMap = Readonly<{}>;
const events = {} as IconEventMap;
export type IconProps = WebComponentProps<IconElement, IconEventMap>;
export const Icon = createComponent({
    elementClass: IconElement, events, react: React, tagName: "vaadin-icon"
});
